import { render, staticRenderFns } from "./BookButtonNew.vue?vue&type=template&id=60077124&"
import script from "./BookButtonNew.vue?vue&type=script&lang=js&"
export * from "./BookButtonNew.vue?vue&type=script&lang=js&"
import style0 from "./BookButtonNew.vue?vue&type=style&index=0&id=60077124&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports